import type { Host } from '@wix/sdk-types';

type ContextIds = {
  accountId: string;
  userId: string;
  siteId?: string;
  appId?: string;
};

export type AdminHost = Host & {
  admin?: {
    getContextIds?: () => ContextIds;
    openItemSelector?: (...args: any[]) => any;
  };
};

export type InternalSDK = {
  getContextIds?: () => ContextIds;
};

export type ItemSelectorSDK = {
  openItemSelector?: (...args: any[]) => any;
};
